import * as React from 'react';
import { cn } from '@/utils/style';

export interface InputProps extends React.ComponentProps<'input'> {
  icon?: React.ReactNode;
  noBorder?: boolean;
  error?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, icon, error, noBorder = false, ...props }, ref) => {
    const Comp = (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30  h-9 w-full min-w-0 rounded-lg  bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm ',
          {
            'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] border border-input file:border-0 border-gray-300':
              !noBorder,
          },
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          icon && 'pl-9',
          className,
          error && 'border-red-500'
        )}
        {...props}
      />
    );

    if (icon) {
      return (
        <div className="relative">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground [&>svg]:size-4 pointer-events-none">
            {icon}
          </div>
          {Comp}
        </div>
      );
    }

    return Comp;
  }
);
Input.displayName = 'Input';
